/** 用户服务协议版本号，条款更新时递增 */
export const SERVICE_TERMS_VERSION = '2026-07-13'
